import { useNavigate, useParams } from "react-router-dom";
import { PoliciesTable } from "../../components/policies-table/policies-table.comp";
import { carriersService } from "../../services";
import { useEffect, useState } from "react";
import { Carrier } from "@bluefalcon/clients-management-client-fetch";
import { LoadingSpinner } from "@bluefalcon/components-package";
import { Box, Heading } from "@chakra-ui/react";
import { toast } from "../../utils/toast.utils";

export function CarrierDetails() {

    const navigate = useNavigate();
    const { carrierId } = useParams();
    const carrierIdNumber = parseInt(carrierId ?? '', 10);
    const [isLoading, setIsLoading] = useState(false);
    const [carrier, setCarrier] = useState<Carrier>();

    const getCarrierById = async (carrierId: number) => {
        setIsLoading(true);
        const found = await carriersService.getCarrierById(carrierId);
        if (!found) {
            navigate('/carriers');
            toast(`No Carrier found with id ${carrierId}`, 'error');
        } else {
            setCarrier(found);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        if (!isNaN(carrierIdNumber)) {
            getCarrierById(carrierIdNumber);
        }
    }, [carrierIdNumber]);

    if (isLoading || !carrier) {
        return <LoadingSpinner />
    }

    return (
        <Box p={4}>
            <Heading as={'h1'} size={'lg'}>Carrier Details</Heading>
            <Heading as={'h3'} size={'md'}>{carrier.name}</Heading>
            <PoliciesTable
                carrier={carrier}
            />
        </Box>
    );
}
